<template>
  <div class="app-elements__list">
    <b-row class="pb-2">
      <b-col
        cols="12"
        md="4"
        class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
      >
        <template v-if="perPageOptions.length > 1">
          <span class="mr-1 text-muted">Показать</span>
          <v-select
            v-model="perPage"
            :options="perPageOptions"
            :clearable="false"
            size="sm"
            class="per-page-selector mr-1"
          />
        </template>
      </b-col>
      <b-col
        cols="12"
        md="8"
      >
        <div class="d-flex align-items-center justify-content-end">
          <!-- Search field -->
          <template v-if="searchFieldActive">
            <b-input-group class="input-group-merge">

              <b-input-group-prepend is-text>
                <feather-icon
                  icon="SearchIcon"
                  class="text-muted"
                />
              </b-input-group-prepend>
              <b-form-input
                v-model="searchQuery"
                placeholder="Поиск"
                debounce="500"
              />
            </b-input-group>
          </template>

          <!-- Representation -->
          <template v-if="itemViewOptions.filter(el=> el.available).length > 1">
            <b-form-radio-group
                  v-model="itemView"
                  class="list item-view-radio-group ml-1"
                  buttons
                  button-variant="outline-primary"
            >
              <b-form-radio
                v-for="option in itemViewOptions"
                v-if="option.available"
                :key="option.value"
                :value="option.value"
              >
                <feather-icon
                  :icon="option.icon"
                />
              </b-form-radio>
            </b-form-radio-group>
          </template>

          <!-- Add sidebar -->
          <template v-if="addDataSidebarAvailable">
            <b-button
                  variant="primary"
                  class="btn-icon rounded-circle ml-1"
                  @click="()=> {store.commit(`${storeModuleName}/SET_IS_ADD_NEW_ELEMENT_COLLAPSED`, true)}"
          >
              <feather-icon icon="PlusIcon"/>
          </b-button>
          </template>
        </div>
      </b-col>
    </b-row>
    <div class="app-elements__representations-container">
      <table-representation
              v-if="itemView === 'table-view'"
              :sort-by="sortBy"
              :fetched-data="fetchedData"
              :table-columns="tableColumns"
              :is-sort-dir-desc="isSortDirDesc"
              :data-loading="dataLoading"
              @sort-changed="(val)=> { sortBy = val.sortBy; isSortDirDesc = val.sortDesc}"
              @selected="(val) => selected = val"
    >

      <template #tableCellCustomRepresentations="cell">
          <slot name="tableCellCustomRepresentations" v-bind="cell"></slot>
      </template>
    </table-representation>

      <grid-representation
                v-if="itemView === 'grid-view'"
                :sort-by="sortBy"
                :fetched-data="fetchedData"
                :is-sort-dir-desc="isSortDirDesc"
                :data-loading="dataLoading"
        >
        <template #gridRepresentationCard="object">
          <slot name="gridRepresentationCard" v-bind="object"></slot>
        </template>
      </grid-representation>

      <slot name="extraRepresentations" v-bind="{itemView, fetchedData}"></slot>
    </div>
    <b-row class="pt-2">
      <b-col
        cols="12"
        sm="6"
        class="d-flex align-items-center justify-content-center justify-content-sm-start"
      >
        <span class="text-muted">Показываем от {{ dataMeta.from }} до {{ dataMeta.to }} из {{ dataMeta.of }} записей</span>
      </b-col>
      <!-- Pagination -->
      <b-col
        cols="12"
        sm="6"
        class="d-flex align-items-center justify-content-center justify-content-sm-end"
      >

        <b-pagination
          v-model="currentPage"
          :total-rows="totalElements"
          :per-page="perPage"
          first-number
          last-number
          class="mb-0 mt-1 mt-sm-0"
          prev-class="prev-item"
          next-class="next-item"
        >
          <template #prev-text>
            <feather-icon
              icon="ChevronLeftIcon"
              size="18"
            />
          </template>
          <template #next-text>
            <feather-icon
              icon="ChevronRightIcon"
              size="18"
            />
          </template>
        </b-pagination>

      </b-col>
    </b-row>

    <!--  extra actions -->
    <div class="app-elements__extra-actions-container" v-if="selected && Object.values(selected).length > 0">
      <hr class="app-elements__divider">
      <slot name="extraActionsCard" v-bind="selected"></slot>
    </div>
  </div>
</template>

<script>


import {
  BCard, BRow, BCol, BButton, BTable, BLink,
  BDropdown, BDropdownItem, BPagination, BSpinner, BInputGroup, BInputGroupPrepend, BFormInput, BFormRadioGroup, BFormRadio
} from 'bootstrap-vue'
import vSelect from 'vue-select'

import ElementListAddNew from '../appElementListAddNew/AppElementListAddNew'

import TableRepresentation from '../appElementList/appElementListRepresenration/table-representation/TableRepresentation'
import GridRepresentation from '../appElementList/appElementListRepresenration/grid-representation/GridRepresentation'

import useElementList from './useAppElementList'

import { watch, onMounted } from '@vue/composition-api'
import store from '@/store'




export default {
  components: {
    ElementListAddNew,

    TableRepresentation,
    GridRepresentation,

    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BLink,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    BFormRadioGroup,
    BFormRadio,
    BInputGroup,
    BInputGroupPrepend,

    vSelect,
  },
  props: {

    // urls for data manipulation
    fetchDataUrl: {
      type: String,
      default: "",
      required: true
    },
    addDataUrl: {
      type: String,
      default: "",
      required: false
    },
    deleteDataUrl: {
      type: String,
      default: "",
      required: false
    },


    fetchDataOnMounted: {
      type: Boolean,
      default: true,
      required: false
    },



    extraTableColumns: {
      type: Array,
      default: () => {
        return []
      },
      required: false
    },
    formFields: {
      type: Array,
      default: () => [],
      required: false
    },
    extraFilters: {
      type: Object,
      default: () => {
        return {}
      },
    },
    extraActions: {
      type: Object,
      default: () => {},
    },

    searchFieldActive: {
      type: Boolean,
      default: false
    },


    storeModuleName: {
      type: String,
      default: "",
      required: false
    },


    tableRepresentation: {
      type: Boolean,
      default: true,
      required: false
    },
    gridRepresentation: {
      type: Boolean,
      default: false,
      required: false
    },

    perPageConfig: {
      type: Number,
      default: 10,
      required: false
    },
    perPageOptionsConfig: {
      type: Array,
      default: () => [10, 25, 50],
      required: false
    },

    addDataSidebarAvailable: {
      type: Boolean,
      default: true,
      required: false
    },

    useDefaultActions: {
      type: Array,
      default: () => [],
      required: false
    },

    idKey: {
      type: String,
      default: "uuid",
      required: false
    },

    extraViews: {
      type: Array,
      default: () => [],
      required: false
    }

  },

  setup(props) {


    const {
      tableColumns,

      fetchData,
      refetchData,
      fetchedData,
      perPage,
      currentPage,
      totalElements,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      dataLoading,
      extraFilters,


      // UI
      itemView,
      itemViewOptions,

      selected

    } = useElementList({
      fetchDataUrl:props.fetchDataUrl,
      deleteDataUrl:props.deleteDataUrl,
      tableColumns: props.extraTableColumns,
      storeModuleName: props.storeModuleName,

      //  representation
      tableView: props.tableRepresentation,
      gridView: props.gridRepresentation,
      mapView: props.mapRepresentation,

      extraViews: props.extraViews,

      perPage: props.perPageConfig,
      perPageOptions: props.perPageOptionsConfig,

      useDefaultActions: props.useDefaultActions,
      idKey: props.idKey,

    });


    watch(() => props.extraFilters, (value) => {
      extraFilters.value = value
    }, {deep: true});

    if (props.fetchDataOnMounted) {
      onMounted(()=> refetchData())
    }


    return {
      tableColumns,

      fetchData,
      fetchedData,
      perPage,
      currentPage,
      totalElements,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      dataLoading,

      // UI
      itemView,
      itemViewOptions,

      store,

      selected
    }
  },
}
</script>

<!--<style lang="scss" scoped>-->
<!--@import '@core/scss/vue/libs/vue-select.scss';-->
<!--</style>-->


<style lang="scss" scoped>
  .app-elements__list {
    display: flex;
    flex-direction: column;
    height: 100%;
    position: relative;
  }
  .app-elements__representations-container {
    flex-grow: 1;
    margin-left: -1.5rem;
    margin-right: -1.5rem;
  }
  .app-elements__divider {
    margin: 1.5rem  -1.5rem;
  }
  .per-page-selector {
    width: 80px;
  }
</style>
